import React from 'react'
import { AiOutlineClose } from "react-icons/ai";

const Hiddenprojectinfo = ({projectinfo,setprojectinfo,ele}) => {
  const {image,text,alt,link,date,tech}=ele;
  return (
    <div className={`${projectinfo?`scale-100`:`scale-0`} transition-all duration-500 ease-in flex fixed top-0 flex-col bg-aboutbg  items-center py-6 min-h-screen h-max w-screen  z-50 left-0  `}>
    <div className=' bg-whatbg h-full   rounded-xl    w-11/12 flex  flex-col  items-center gap-y-10 py-4'>
      {/* title */}
     <div className='w-full flex items-center justify-between'>
    <div className='text-white capitalize text-4xl w-11/12 text-center lg:w-full'>{alt}</div>
    <AiOutlineClose className='cursor-pointer text-white mr-4 text-4xl' onClick={()=>{setprojectinfo(false)}}/> 
     </div>
        {/*image */}
    <div className='w-11/12 min-h-[620px]  flex lg:flex-col  gap-6 items-center md:items-start'>
     <div className='w-1/2 lg:w-full md:w-full h-full border-2 flex items-center justify-center  '>
      <img src={image} alt={alt} />  
     </div>
     {/* desc */}

     <div className='w-1/2 h-full gap-10  lg:w-full p-2 flex flex-col justify-evenly lg:gap-4  '>
      <div className='text-white capitalize text-2xl '>project info:</div>
      <div className='text-white capitalize w-3/4 lg:w-full '>{text}</div>
      <div className='text-white capitalize  font-bold text-xl' >project details:</div>
      <div className='text-white capitalize border-b-1 border-abouttext mb-3'>name: {alt}</div>
      <div className='text-white capitalize border-b-1 border-abouttext mb-3'>technology:{tech}</div>
      <div className='text-white capitalize border-b-1 border-abouttext mb-3'>date:{date}</div>
      <div className='text-white capitalize border-b-1 border-abouttext mb-3'>url:<a href={link} className='text-red'>{link}</a></div>
      {/* <div className='text-white capitalize '>share</div>   */}
    </div> 
    </div>
    </div>

    </div>
  )
}

export default Hiddenprojectinfo
